module.exports = __webpack_public_path__ + "img/sec3_1.180a5174.png";